module.exports = __webpack_public_path__ + "img/Christmas-hand.3747adc.png";